<template>
  <div class="p-6">
    <div id="logged-out-header" class="flex items-center space-x-3 mb-6">
      <img src="/logo.png" alt="Compasso Logo" class="size-8" />
      <span class="truncate text-gray-900 dark:text-white font-semibold">Compasso</span>
    </div>
    <slot />
  </div>
</template>
